import one from '../assets/svg/projects/one.svg'
import two from '../assets/svg/projects/two.svg'
import three from '../assets/svg/projects/three.svg'
import four from '../assets/svg/projects/four.svg'
// import five from '../assets/svg/projects/five.svg'
// import six from '../assets/svg/projects/six.svg'
// import seven from '../assets/svg/projects/seven.svg'
// import eight from '../assets/svg/projects/eight.svg'


export const projectsData = [
  {
    id: 1,
    projectName: "Real Estate Website",
    projectDesc:
      '"RealEstate-MERNStack is a modern real estate website built with the MERN stack, offering seamless property browsing and listing features. It uses Firebase for authentication and data management, and Tailwind CSS for a sleek, responsive design."',
    tags: ["React", "Node", "JavaScript"],
    code: "https://github.com/akashp73387/Project-RealEstate-Frontend",
    demo: " https://mern-estate-lodz.onrender.com/",
    image: one,
  },
  {
    id: 2,
    projectName: "Task Management App",
    projectDesc:
      "An app facilitating task planning, tracking, collaboration, and milestone setting for enhanced productivity.",
    tags: ["React", "Node", "JavaScript"],
    code: "https://github.com/akashp73387/Task-Management-App-Project---Frontend",
    demo: "https://inspiring-zuccutto-b29727.netlify.app/",
    image: two,
  },
  {
    id: 3,
    projectName: "E-Commerce Website",
    projectDesc:
      "An e-commerce platform that allows users to browse products, add them to their cart, and complete purchases. ",
    tags: ["React", "Node", "JavaScript"],
    code: "https://github.com/akashp73387/E-commerse-Website-Project--Frontend---Backend",
    demo: "https://mern-shop-abxs.onrender.com/",
    image: three,
  },
  {
    id: 4,
    projectName: "Expenses Tracker App",
    projectDesc:
      "A user-friendly application that helps users to track and manage their daily expenses.",
    tags: ["React", "Node", "JavaScript"],
    code: "https://github.com/akashp73387/Expense-Tracker-Project---FrontEnd",
    demo: "  https://main.d4ed8we1flo2r.amplifyapp.com/",
    image: four,
  },
];


